export const YouTubeConst = {
  BASE_URL: 'https://www.youtube.com/embed/',
};
